import React, { Component } from 'react';

class Elements extends Component {
    constructor(props) {
        super(props)
    }

    //ELEMENTOS SELECCIONADOS (PERTENECIENTE A LAS PANTALLAS)
    render() {
        return (
            <div className="row">
                <div className="col-md-1">
                    <label>Producto</label>
                </div>
                <div className="col-md-1">
                    <label>></label>
                </div>
                <div className="col-md-1">
                    <label>Empresa</label>
                </div>
                <div className="col-md-1">
                    <label>></label>
                </div>
                <div className="col-md-1">
                    <label>Cuenta</label>
                </div>
                <div className="col-md-1">
                    <label>></label>
                </div>
                <div className="col-md-1">
                    <label>Tarjetas</label>
                </div>
                <div className="col-md-1">
                    <label>></label>
                </div>
                <div className="col-md-4">
                    <label>Confirmación</label>
                </div>
            </div>
        );
    }
};

export default Elements